/* =========================================================================== *\
  Mock API – Stock Counting System
  ใช้แทน FetchData จริงระหว่างพัฒนา/ทดสอบ
\* =========================================================================== */

// ── Seed data ──────────────────────────────────────────────────────────────────

let idCounter = 10;
const nextId = () => {
  idCounter += 1;
  return idCounter;
};

/** สาขา */
export const MOCK_BRANCHES = [
  { id: 1, name: 'สาขาสำนักงานใหญ่' },
  { id: 2, name: 'สาขาลาดพร้าว' },
  { id: 3, name: 'สาขารามคำแหง' },
  { id: 4, name: 'สาขาบางนา' },
  { id: 5, name: 'สาขาเชียงใหม่' },
];

/** ใบนับหลัก */
const MOCK_STOCK_TAKES = [
  {
    id: 1,
    code: 'ST-00001',
    branch_id: 1,
    branch_name: 'สาขาสำนักงานใหญ่',
    remark: 'นับประจำไตรมาส Q1/2026',
    status: 'active',
    session_count: 2,
    products: [],
    created_at: '2026-03-01T09:00:00',
    created_by_name: 'Admin',
  },
  {
    id: 2,
    code: 'ST-00002',
    branch_id: 2,
    branch_name: 'สาขาลาดพร้าว',
    remark: '',
    status: 'draft',
    session_count: 0,
    products: [],
    created_at: '2026-04-10T14:30:00',
    created_by_name: 'Admin',
  },
];

/** สินค้าสำหรับ search */
const MOCK_PRODUCTS = [
  {
    barcode_id: 101,
    barcode: 'BRC-001',
    name: 'น้ำดื่มตราช้าง 600ml',
    unit_name: 'ขวด',
    quantity_balance: 2400,
    image_url: '',
  },
  {
    barcode_id: 102,
    barcode: 'BRC-002',
    name: 'ข้าวสารหอมมะลิ 5kg',
    unit_name: 'ถุง',
    quantity_balance: 350,
    image_url: '',
  },
  {
    barcode_id: 103,
    barcode: 'BRC-003',
    name: 'น้ำมันพืชตราแม่ประนอม 1L',
    unit_name: 'ขวด',
    quantity_balance: 180,
    image_url: '',
  },
  {
    barcode_id: 104,
    barcode: 'BRC-004',
    name: 'น้ำตาลทรายขาว 1kg',
    unit_name: 'ถุง',
    quantity_balance: 520,
    image_url: '',
  },
  {
    barcode_id: 105,
    barcode: 'BRC-005',
    name: 'ซอสถั่วเหลืองตราแม่ครัว',
    unit_name: 'ขวด',
    quantity_balance: 95,
    image_url: '',
  },
  {
    barcode_id: 106,
    barcode: 'BRC-006',
    name: 'ผงซักฟอก Breeze 3kg',
    unit_name: 'กล่อง',
    quantity_balance: 210,
    image_url: '',
  },
  {
    barcode_id: 107,
    barcode: 'BRC-007',
    name: 'สบู่ Lifebuoy 125g',
    unit_name: 'ก้อน',
    quantity_balance: 660,
    image_url: '',
  },
  {
    barcode_id: 108,
    barcode: 'BRC-008',
    name: 'แชมพู Head & Shoulders 300ml',
    unit_name: 'ขวด',
    quantity_balance: 145,
    image_url: '',
  },
  {
    barcode_id: 109,
    barcode: 'BRC-009',
    name: 'ยาสีฟัน Colgate 150g',
    unit_name: 'หลอด',
    quantity_balance: 430,
    image_url: '',
  },
  {
    barcode_id: 110,
    barcode: 'BRC-010',
    name: 'กระดาษ A4 80g 500แผ่น',
    unit_name: 'รีม',
    quantity_balance: 88,
    image_url: '',
  },
  {
    barcode_id: 111,
    barcode: 'BRC-011',
    name: 'ปากกาลูกลื่น Pilot 0.7mm',
    unit_name: 'ด้าม',
    quantity_balance: 1200,
    image_url: '',
  },
  {
    barcode_id: 112,
    barcode: 'BRC-012',
    name: 'กระดาษลัง 40x60cm',
    unit_name: 'แผ่น',
    quantity_balance: 3000,
    image_url: '',
  },
];

/** Counting sessions */
const MOCK_SESSIONS = [
  {
    id: 1,
    code: 'CS-00001',
    stock_take_id: 1,
    stock_take_code: 'ST-00001',
    stock_take_name: 'นับประจำไตรมาส Q1/2026',
    name: 'รอบนับครั้งที่ 1 (ทีม A)',
    remark: 'นับเช้า',
    status: 'submitted',
    counted_products: 10,
    items: [],
    created_at: '2026-03-05T08:00:00',
    created_by_name: 'Admin',
  },
  {
    id: 2,
    code: 'CS-00002',
    stock_take_id: 1,
    stock_take_code: 'ST-00001',
    stock_take_name: 'นับประจำไตรมาส Q1/2026',
    name: 'รอบนับครั้งที่ 2 (ทีม B)',
    remark: '',
    status: 'open',
    counted_products: 4,
    items: [],
    created_at: '2026-03-06T13:00:00',
    created_by_name: 'Admin',
  },
];

// ── Helper ─────────────────────────────────────────────────────────────────────

const delay = (ms = 350) => new Promise((r) => setTimeout(r, ms));

const paginate = (arr, page, perPage) => {
  const start = (page - 1) * perPage;
  return arr.slice(start, start + perPage);
};

const filterText = (arr, search, fields) => {
  if (!search) return arr;
  const q = search.toLowerCase();
  return arr.filter((item) =>
    fields.some((f) =>
      String(item[f] ?? '')
        .toLowerCase()
        .includes(q)
    )
  );
};

// ── API Mock Functions ─────────────────────────────────────────────────────────

/** GET /stock_take  → list */
export const mockListStockTakes = async ({
  search = '',
  page = 1,
  per_page = 10,
  status = 'ALL',
} = {}) => {
  await delay();
  let data = MOCK_STOCK_TAKES;
  if (status !== 'ALL') data = data.filter((r) => r.status === status);
  data = filterText(data, search, ['code', 'branch_name', 'remark']);
  const total = data.length;
  return {
    status: 'ok',
    data: paginate(data, page, per_page),
    total_pages: Math.ceil(total / per_page),
    page,
  };
};

/** GET /stock_take/:id  → detail */
export const mockGetStockTake = async (id) => {
  await delay();
  const item = MOCK_STOCK_TAKES.find((r) => r.id === Number(id));
  if (!item) return { status: 'error', msg: 'not_found' };
  return { status: 'ok', data: { ...item } };
};

/** PUT /stock_take  → create */
export const mockCreateStockTake = async ({ branch_id, remark }) => {
  await delay(500);
  const branch = MOCK_BRANCHES.find((b) => b.id === Number(branch_id));
  const newItem = {
    id: nextId(),
    code: `ST-${String(nextId()).padStart(5, '0')}`,
    branch_id: Number(branch_id),
    branch_name: branch?.name ?? '',
    remark: remark ?? '',
    status: 'draft',
    session_count: 0,
    products: [],
    created_at: new Date().toISOString(),
    created_by_name: 'Admin',
  };
  MOCK_STOCK_TAKES.unshift(newItem);
  return { status: 'ok', id: newItem.id };
};

/** PATCH /stock_take/:id  → update */
export const mockUpdateStockTake = async (id, { branch_id, remark }) => {
  await delay(400);
  const idx = MOCK_STOCK_TAKES.findIndex((r) => r.id === Number(id));
  if (idx === -1) return { status: 'error', msg: 'not_found' };
  const branch = MOCK_BRANCHES.find((b) => b.id === Number(branch_id));
  MOCK_STOCK_TAKES[idx] = {
    ...MOCK_STOCK_TAKES[idx],
    branch_id: Number(branch_id),
    branch_name: branch?.name ?? MOCK_STOCK_TAKES[idx].branch_name,
    remark: remark ?? '',
  };
  return { status: 'ok' };
};

/** OPTIONS /stock_take/status  → change status */
export const mockChangeStockTakeStatus = async (id, status) => {
  await delay(400);
  const idx = MOCK_STOCK_TAKES.findIndex((r) => r.id === Number(id));
  if (idx === -1) return { status: 'error', msg: 'not_found' };
  MOCK_STOCK_TAKES[idx].status = status;
  return { status: 'ok' };
};

/** POST /stock_take/:id/product  → add product */
export const mockAddProductToStockTake = async (stockTakeId, product) => {
  await delay(300);
  const idx = MOCK_STOCK_TAKES.findIndex((r) => r.id === Number(stockTakeId));
  if (idx === -1) return { status: 'error' };
  const already = MOCK_STOCK_TAKES[idx].products.find((p) => p.barcode_id === product.barcode_id);
  if (already) return { status: 'error', msg: 'duplicate' };
  MOCK_STOCK_TAKES[idx].products.push(product);
  return { status: 'ok' };
};

/** DELETE /stock_take/:id/product/:barcodeId  → remove product */
export const mockRemoveProductFromStockTake = async (stockTakeId, barcodeId) => {
  await delay(300);
  const idx = MOCK_STOCK_TAKES.findIndex((r) => r.id === Number(stockTakeId));
  if (idx === -1) return { status: 'error' };
  MOCK_STOCK_TAKES[idx].products = MOCK_STOCK_TAKES[idx].products.filter(
    (p) => p.barcode_id !== Number(barcodeId)
  );
  return { status: 'ok' };
};

/** POST /product_search  → search products */
export const mockSearchProducts = async ({
  search = '',
  page = 1,
  per_page = 7,
  barcode_ids = null,
} = {}) => {
  await delay();
  let data = MOCK_PRODUCTS;
  if (barcode_ids && barcode_ids.length > 0) {
    data = data.filter((p) => barcode_ids.includes(p.barcode_id));
  }
  data = filterText(data, search, ['barcode', 'name']);
  return {
    status: 'ok',
    data: paginate(data, page, per_page),
    total_pages: Math.ceil(data.length / per_page),
    page,
  };
};

// ── Session API ────────────────────────────────────────────────────────────────

/** POST /counting_session  → list sessions by stock_take_id */
export const mockListSessions = async ({ stock_take_id, page = 1, per_page = 10 } = {}) => {
  await delay();
  const data = MOCK_SESSIONS.filter((s) => s.stock_take_id === Number(stock_take_id));
  return {
    status: 'ok',
    data: paginate(data, page, per_page),
    total_pages: Math.ceil(data.length / per_page),
    page,
  };
};

/** GET /counting_session/:id */
export const mockGetSession = async (id) => {
  await delay();
  const item = MOCK_SESSIONS.find((s) => s.id === Number(id));
  if (!item) return { status: 'error', msg: 'not_found' };
  // populate items from stock take products
  const st = MOCK_STOCK_TAKES.find((r) => r.id === item.stock_take_id);
  const items = (st?.products ?? []).map((p) => ({
    ...p,
    quantity_stock: p.quantity_balance,
    quantity_counted: '',
    remark: '',
    saved: false,
  }));
  return { status: 'ok', data: { ...item, items } };
};

/** PUT /counting_session  → create */
export const mockCreateSession = async ({ stock_take_id, name, remark }) => {
  await delay(500);
  const st = MOCK_STOCK_TAKES.find((r) => r.id === Number(stock_take_id));
  const newId = nextId();
  const session = {
    id: newId,
    code: `CS-${String(newId).padStart(5, '0')}`,
    stock_take_id: Number(stock_take_id),
    stock_take_code: st?.code ?? '',
    stock_take_name: st?.branch_name ?? '',
    name,
    remark: remark ?? '',
    status: 'open',
    counted_products: 0,
    items: [],
    created_at: new Date().toISOString(),
    created_by_name: 'Admin',
  };
  MOCK_SESSIONS.push(session);
  // bump session_count in parent
  if (st) st.session_count = (st.session_count ?? 0) + 1;
  return { status: 'ok', id: newId };
};

/** PATCH /counting_session/:id */
export const mockUpdateSession = async (id, { name, remark }) => {
  await delay(400);
  const idx = MOCK_SESSIONS.findIndex((s) => s.id === Number(id));
  if (idx === -1) return { status: 'error' };
  MOCK_SESSIONS[idx] = { ...MOCK_SESSIONS[idx], name, remark };
  return { status: 'ok' };
};

/** OPTIONS /counting_session/status */
export const mockChangeSessionStatus = async (id, status) => {
  await delay(400);
  const idx = MOCK_SESSIONS.findIndex((s) => s.id === Number(id));
  if (idx === -1) return { status: 'error' };
  MOCK_SESSIONS[idx].status = status;
  return { status: 'ok' };
};

/** POST /counting_session/:id/item  → save item qty */
export const mockSaveSessionItem = async (sessionId, { barcode_id, quantity_counted, remark }) => {
  await delay(250);
  // In real API this would persist to DB; here we just acknowledge
  return { status: 'ok', barcode_id, quantity_counted, remark };
};

/** GET branches */
export const mockGetBranches = async () => {
  await delay(200);
  return { status: 'ok', data: MOCK_BRANCHES };
};
